<template>
  <div class="add-btn-box" @click.prevent>
    <div class="add-card-div">
      <button
        class="add-card-btn"
        :class="{
          active: select_active && has_variant,
        }"
        @click="toggle"
      >
        <span v-if="stock" class="text-uppercase add">ADD+</span>
        <span class="text-uppercase select"> Select </span>
      </button>
    </div>
    <div class="add-select-div" ref="addSelectDiv" v-if="has_variant">
      <div class="select-div-box">
        <div
          v-for="(item, index) in product_res.variant_attrs"
          :key="item.name + index"
          :style="{
            width: is_special_attr(item.special_native_name)
              ? ` calc(${
                  100 / $store.state.special_attr_num
                }% - 10px) !important`
              : '',
          }"
        >
          <v-selectStyle
            :attrs="item"
            :index="index"
            :variant_attrs="variant_attrs"
            :theme="theme"
            :show_dropdown="true"
          ></v-selectStyle>
        </div>

        <div class="add-btn">
          <button
            class="add-card-btn transition-main"
            @click="cartAdd"
          >
            <span class="text-uppercase add">Add to Cart</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelectStyle from "../product/selectStyle.vue";
export default {
  props: ["theme", "product_res", "variant_attrs", "stock"],
  data() {
    return {
      select_active: false,
    };
  },
  methods: {
    is_special_attr(name) {
      let { special_attr_key } = this.$store.state;
      if (!name || !special_attr_key) return false;
      else if (name.toLowerCase() == special_attr_key) return true;
    },
    toggle() {
      this.select_active = !this.select_active;
      if (!this.has_variant) this.$emit("clickAdd");
      this.$(this.$refs.addSelectDiv).animate({ height: "toggle" }, 300);
    },
    cartAdd() {
      this.$emit('clickAdd');
      this.select_active = false;
      this.$(this.$refs.addSelectDiv).animate({ height: 'toggle' }, 500);
    }
  },
  computed: {
    has_variant() {
      let { variant_attrs } = this.product_res;
      if (variant_attrs && variant_attrs.length) return true;
    },
  },
  mounted() {
    this.bus.$on('guesslike_cart_slide_swiper',() => {
      if(this.select_active) {
        this.select_active = false;
        this.$(this.$refs.addSelectDiv).animate({ height: "toggle" }, 0);
      } 
    })
  },
  components: {
    vSelectStyle,
  },
};
</script>
<style scoped lang='scss'>
.add-btn-box {
  margin-top: 30px;
  .add-card-div {
    line-height: 1;
    .add-card-btn {
      text-align: right;
      width: 100%;
      font-size: 16px;
      padding: 0 10px;
      outline: none;
      & > span {
        text-decoration: underline;
        font-size: 15px;
        font-weight: bold;
      }
      .select {
        display: none;
        .plus {
          position: absolute;
          right: 0;
          top: 18px;
          &::after,
          &::before {
            content: "";
            position: absolute;
            right: 18px;
            height: 16px;
            top: 3px;
            border-left: 2px solid #000;
            transition: transform 250ms ease 0s;
          }
          &::after {
            transform: rotate(90deg);
          }
          &::before {
            transform: rotate(0deg);
          }
        }
      }
      .add {
        justify-content: center;
      }
      //   &.hover_active:hover,
      &.active {
        .add {
          display: none;
        }
        .select {
          display: block;
        }
      }
      &.active {
        .select {
          .plus {
            &::before {
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
  .add-select-div {
    display: none;
    margin-top: 12px;
    .select-div-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      & > div {
        width: 100%;
      }
      .add-btn {
        button {
          text-align: center;
          width: 100%;
          font-size: 16px;
          padding: 0 10px;
          outline: none;
          height: 48px;
          line-height: 48px;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .add-btn-box {
    margin-top: 9px;
    .add-card-div {
      .add-card-btn {
        & > span {
          font-size: 12px;
        }
        .select {
          .plus {
            top: 5px;
          }
        }
      }
    }
    .add-select-div {
      .select-div-box {
        &::v-deep {
          .select-style-box {
            .default-select {
              select {
                height: 34px;
                padding: 6px;
                font-size: 12px;
              }
            }
          }
        }
      }
      .add-btn {
        & > button {
          height: 32px !important;
          line-height: 32px !important;
          font-size: 12px !important;
        }
      }
    }
  }
}
</style>